module.exports = __webpack_public_path__ + "static/media/porte5.655e7763.jpg";